export default __webpack_public_path__ + "static/media/lp-02-header-03-desktop.4d7325aa.png";